import React, { useEffect, useState } from "react";
import { sendMail } from "../../utils/sendMail";

import "./popUp.css";

const PopUp = ({ togglePopUp, prefilledData }) => {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    query: "", // Add this

    // country: "",
  });

  useEffect(() => {
    console.log("form data:", formData);
  }, [formData]);

  useEffect(() => {
    if (prefilledData) {
      console.log("prefilled data:", prefilledData);
      setFormData(prefilledData); // Ensure this triggers a new state update
    }
  }, [prefilledData]);
  // Define handleInputChange within the component
  const handleInputChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   const mobileInput = document.getElementById("mobile");

  //   // Check if the mobile input value is exactly 10 digits
  //   if (formData.mobile.length !== 10) {
  //     mobileInput.setCustomValidity("Mobile number must be exactly 10 digits.");
  //     mobileInput.reportValidity(); // Show the custom error message
  //   } else {
  //     mobileInput.setCustomValidity(""); // Clear the error message

  //     setIsSubmitted(true);
  //     setTimeout(() => {
  //      setIsSubmitted(false);
  //      togglePopUp(); // Close the pop-up
  //     }, 1000); // Hide success message after 2 seconds

  //   //   console.log("Form Submitted:", formData);

  //     // Proceed with further actions, like sending the data to the backend
  //   }
  // };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   const mobileInput = document.getElementById("mobile");

  //   if (formData.mobile.length !== 10) {
  //     mobileInput.setCustomValidity("Mobile number must be exactly 10 digits.");
  //     mobileInput.reportValidity();
  //     return;
  //   }

  //   mobileInput.setCustomValidity(""); // clear error

  //   // 👇 Send email using Firebase Email Trigger
  //   try {
  //     await sendMail(
  //       formData.email, // send to client's own email
  //       `Thanks for Your Query, ${formData.name || "Client"}`,
  //       `<p><strong>Name:</strong> ${formData.name}</p>
  //      <p><strong>Mobile:</strong> ${formData.mobile}</p>
  //      <p><strong>Email:</strong> ${formData.email}</p>
  //     //  <p><strong>Country:</strong> ${formData.country}</p>
  //      <p><strong>Query:</strong> ${document.getElementById("query").value}</p>
  //      <p>We'll get back to you shortly!</p>`
  //     );

  //     setIsSubmitted(true);
  //     setTimeout(() => {
  //       setIsSubmitted(false);
  //       togglePopUp();
  //     }, 1500);
  //   } catch (err) {
  //     alert("Failed to send email. Try again later.");
  //   }
  // };
  // import the mail sender at the top

  // inside your PopUp component
  const handleSubmit = async (e) => {
    e.preventDefault();
    const mobileInput = document.getElementById("mobile");

    if (formData.mobile.length !== 10) {
      mobileInput.setCustomValidity("Mobile number must be exactly 10 digits.");
      mobileInput.reportValidity();
      return;
    } else {
      mobileInput.setCustomValidity("");
    }

    try {
      const queryText = document.getElementById("query").value;
      const fullData = { ...formData, query: queryText };

      await sendMail(fullData);

      setIsSubmitted(true);
      setTimeout(() => {
        setIsSubmitted(false);
        togglePopUp();
      }, 1000);
    } catch (err) {
      console.error("❌ Error during form submission:", err);
    }
  };

  return (
    <div className="popUp">
      <div className="close-button">
        <button className="close-popup-btn" onClick={togglePopUp}>
          ✖
        </button>
      </div>
      <div className="popUp-heading">
        <h1>ANY QUERY?</h1>
      </div>

      <form>
        <div className="form-row-popUp">
          <div className="form-group-popUp">
            {/* <label htmlFor="name">Name</label> */}
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Name*"
              required
              value={formData.name}
              onChange={(e) => handleInputChange("name", e.target.value)}
              onInput={(e) => {
                const allowedCharacters = /^[a-zA-Z\s]*$/; // Allow only uppercase, lowercase letters, and spaces
                if (!allowedCharacters.test(e.target.value)) {
                  e.target.value = e.target.value.slice(0, -1); // Remove the last entered character if invalid
                }
              }}
            />
          </div>

          <div className="form-group-popUp">
            {/* <label htmlFor="mobile">Mobile Number</label> */}
            <input
              type="tel"
              id="mobile"
              name="mobile"
              placeholder="Mobile Number*"
              required
              maxLength="10" // Set maximum input length to 10
              value={formData.mobile}
              // onChange={(e) => handleInputChange('mobile', e.target.value)}
              onChange={(e) => {
                const value = e.target.value;
                handleInputChange("mobile", value);

                // Clear error message dynamically when input reaches 10 digits
                if (value.length === 10) {
                  const mobileInput = document.getElementById("mobile");
                  mobileInput.setCustomValidity("");
                }
              }}
              onInput={(e) => {
                const allowedCharacters = /^[0-9]*$/;
                if (!allowedCharacters.test(e.target.value)) {
                  e.target.value = e.target.value.slice(0, -1); // Remove the last entered character if invalid
                }
              }}
            />
          </div>
        </div>

        <div className="form-row-popUp email-button">
          <div className="form-group-popUp">
            {/* <label htmlFor="email">Email Address</label> */}
            <input
              type="email"
              id="email"
              name="email"
              placeholder="E-mail Address*"
              required
              value={formData.email}
              onChange={(e) => handleInputChange("email", e.target.value)}
            />
          </div>

          <div className="form-group-popUp">
            <button className="submit-btn" type="submit" onClick={handleSubmit}>
              SEND
            </button>
          </div>
        </div>

        <div className="form-row-popUp">
          <div className="form-group-popUp">
            {/* <div className="query-container"> */}
            <textarea
              className="query-popUp"
              type="query"
              id="query"
              name="query"
              placeholder="Your Query*"
              required
              value={formData.query}
              onChange={(e) => handleInputChange("query", e.target.value)}
            />
            {/* </div> */}
          </div>
        </div>
        <div className="form-group-popUp">
          <button
            className="submit-btn-smallScreen"
            type="submit"
            onClick={handleSubmit}
          >
            SEND
          </button>
        </div>
        <h4 className="caption">
          *Mention your query and send to our team, we will reach out to you
          soon!
        </h4>
      </form>
      {/* Success Popup */}
      {isSubmitted && (
        <div className="success-popup">Form submitted successfully!</div>
      )}
    </div>
  );
};

export default PopUp;
